import { createContext, useContext, useState, useCallback } from 'react';
import UpgradeModal from '../components/UpgradeModal';
import { useAppConfig } from './AppConfigContext';

/**
 * Global provider that owns the single <UpgradeModal /> instance and exposes
 * imperative open/close controls. usePaidGate() calls openUpgrade() whenever an
 * unpaid user attempts a gated action. The live "seats left" count is pulled
 * from runtime config and surfaced inside the modal for conversion urgency.
 */
const UpgradeModalContext = createContext({
    open: false,
    openUpgrade: () => {},
    closeUpgrade: () => {},
});

export function UpgradeModalProvider({ children }) {
    const cfg = useAppConfig();
    const [open, setOpen] = useState(false);
    const openUpgrade = useCallback(() => setOpen(true), []);
    const closeUpgrade = useCallback(() => setOpen(false), []);

    return (
        <UpgradeModalContext.Provider value={{ open, openUpgrade, closeUpgrade }}>
            {children}
            <UpgradeModal
                open={open}
                onClose={closeUpgrade}
                seatsLeft={cfg.beta_slots_available}
                seatsTotal={cfg.beta_user_limit}
            />
        </UpgradeModalContext.Provider>
    );
}

export const useUpgradeModal = () => useContext(UpgradeModalContext);
